import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const {
  includedRemoteUrls,
  excludedRemoteUrls,
  eventTypesString,
  eventTypes,
  connectionString,
  shouldTrackAlgoliaRequests,
} = window.Jbhifi?.appInsightsSettings || {};
const ALGOLIA_REQUEST_URL_PART = '/indexes/shopify_products_families';

const shouldTrackUrl = (urlStr: string) => {
  const url = new URL(urlStr);
  const urlPart = `${url.origin}${url.pathname}`.toLowerCase();

  return (
    includedRemoteUrls.some(loggedUrl => urlPart.includes(loggedUrl.toLowerCase())) &&
    !excludedRemoteUrls.some(loggedUrl => urlPart.includes(loggedUrl.toLowerCase()))
  );
};

export const appInsights = connectionString
  ? new ApplicationInsights({
      config: {
        connectionString,
      },
    })
  : undefined;

appInsights?.addTelemetryInitializer(envelope => {
  if (eventTypesString !== '*' && !eventTypes.includes(envelope.baseType || '')) {
    return false;
  }
  if (envelope.baseType === 'RemoteDependencyData' && !shouldTrackUrl(envelope.baseData?.target)) {
    return false;
  }
});

appInsights?.loadAppInsights();
appInsights?.trackPageView();

window.appInsights = appInsights;

(() => {
  /* Tracking algolia requests.  Uses PerformanceObserver as the default app insights 'duration' value was way off and inconsistent */
  if (!shouldTrackAlgoliaRequests) return;
  const isAlgoliaRequestEntry = (
    entry: PerformanceEntry
  ): entry is PerformanceResourceTiming & { responseStatus?: number } => {
    return (
      'transferSize' in entry &&
      typeof entry.transferSize === 'number' &&
      entry.transferSize > 0 &&
      entry.name.includes(ALGOLIA_REQUEST_URL_PART)
    );
  };

  const performanceObserver = new PerformanceObserver(list => {
    for (const entry of list.getEntries().filter(isAlgoliaRequestEntry)) {
      appInsights?.trackDependencyData({
        name: entry.name,
        id: `${entry.name}_${entry?.startTime}`,
        duration: Number(entry.duration.toFixed(1)),
        responseCode: entry.responseStatus ?? 200,
        type: entry.initiatorType || 'fetch',
      });
    }
  });

  performanceObserver.observe({ type: 'resource', buffered: true });
})();
